import { jalaliDateTimeForFileName } from './JalaliDateTimeForFileName';

export const Base64Downloader = async (
  base64String,
  openAfterDownload = true,
  isFullName = false
) => {
  const fileName =
    isFullName || jalaliDateTimeForFileName();

  const contentType = base64String.split(',');

  const contentTypeRegex = /^data:([^;]+);base64/;

  const dataHeader = contentType[0].match(contentTypeRegex);

  if (dataHeader[1].startsWith('image/*')) {
    dataHeader[1] = 'image/jpeg';
  }

  console.log('dataHeader==>', dataHeader);

  // Input validation
  try {
    const response = await fetch(
      `${dataHeader[0]},${base64String.split(',')[1]}`
    );

    // Handle response

    const blob = new Blob([await response.blob()], {
      type: dataHeader[1],
    });

    const url = window.URL.createObjectURL(blob);

    // Get extension from data header
    const extensionMatch = /\/([a-z0-9]+)$/i.exec(
      dataHeader[1]
    );
    const extension = extensionMatch
      ? extensionMatch[1]
      : '';

    // Append extension to filename
    let fullFileName = fileName;
    if (extension) {
      fullFileName += `.${extension}`;
    }

    if (navigator.msSaveBlob) {
      navigator.msSaveBlob(blob, fullFileName);
    } else {
      // Create <a> tag method
      const anchor = document.createElement('a');
      anchor.href = url;
      anchor.download = fullFileName;
      anchor.style.display = 'none';
      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);

      // Open the file in a new browser tab if openAfterDownload is true
      if (openAfterDownload) {
        const newTab = window.open('', '_blank');
        if (newTab) {
          newTab.document.write(
            `<iframe src="${url}" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>`
          );
        }
      }
    }

    window.URL.revokeObjectURL(url);
  } catch (err) {
    // Error handling
    console.error('Error downloading file:', err);
  }
};
